import {
  Activity,
  ClipboardList,
  LayoutList,
  Timer,
  Users,
} from "lucide-react";

export const PRIMARY_NAV_ITEMS = [
  { value: "programme", label: "Programme", icon: LayoutList },
  {
    value: "session",
    label: "Session",
    icon: ClipboardList,
    disableWhenPlanning: true,
  },
  { value: "coach", label: "Coach", icon: Timer, disableWhenPlanning: true },
  { value: "social", label: "Social", icon: Users },
  { value: "activity", label: "Activity", icon: Activity },
];
